<fui-modal [state]="state">
    <fui-modal-window>
        <fui-modal-window-toolbar (closed)="cancelLocalisation()" [title]="'wbo.localisation.heading.modalTitle'">
            <fui-icon [height]="16" [icon]="'globe'" [width]="16"></fui-icon>
        </fui-modal-window-toolbar>
        <fui-modal-window-header>
            <div class="header">
                <fui-switch-control *ngIf="showRestricted" [label]="'wbo.localisation.label.restricted'"
                                    [(ngModel)]="universal"></fui-switch-control>
                <wbo-localisation-outlet-selection-autocomplete [panelComponent]="outletSelectionPanel"
                                                                *ngIf="restricted"></wbo-localisation-outlet-selection-autocomplete>
            </div>
        </fui-modal-window-header>
        <fui-modal-window-main *ngIf="restricted">
            <wbo-localisation-outlet-selection [selectedOutlets]="selectedOutlets"
                                               [selectedCustomObjects]="selectedCustomObjects"></wbo-localisation-outlet-selection>

        </fui-modal-window-main>
        <fui-modal-window-footer>
            <fui-buttons>
                <wbo-cancel-button (click)="cancelLocalisation()"></wbo-cancel-button>
                <wbo-ok-button (click)="confirmLocalisation()" [title]="'wbo.common.button.apply'"></wbo-ok-button>
            </fui-buttons>
        </fui-modal-window-footer>
    </fui-modal-window>
</fui-modal>
